import { render } from "./LeituraBiblicaDiariaPrivacyPolicy.vue?vue&type=template&id=1a190248"
import script from "./LeituraBiblicaDiariaPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LeituraBiblicaDiariaPrivacyPolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__